export default function successToast({
  toast,
  description,
  showIcon = true,
  duration = 1500
}: {
  toast: any
  description: string
  showIcon?: boolean
  duration?: number
}) {
  return toast.add({
    title: description,
    duration,
    icon: showIcon ? 'i-heroicons-exclamation-triangle' : '',
    ui: {
      root: 'bg-[#303338]'
    },
    close: {
      class: 'text-white/80 hover:text-white'
    },
    progress: {
      color: 'success',
      ui: {
        base: 'bg-[#303338]'
      }
    }
  })
}
